import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';
import { environment } from '@environments/environment';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const msalService = inject(MsalService);
    const account = msalService.instance.getActiveAccount();

    if (!account) {
        return next(req);
    }

    return from(
        msalService.instance.acquireTokenSilent({
            scopes: [`api://${environment.ENTRA_ID_CLIENT_ID}/Read`],
            account,
            // redirectUri: `${window.location.origin}/auth-redirect.html`,
        })
    ).pipe(
        switchMap((result) => {
            const authReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${result.accessToken}`,
                },
            });
            return next(authReq).pipe(
                catchError((error: unknown) => {
                    if (error instanceof HttpErrorResponse && error.status === 401) {
                        msalService.logoutRedirect({ account });
                    }
                    return throwError(() => error);
                })
            );
        }),
        catchError((error: unknown) => {
            if (error instanceof InteractionRequiredAuthError) {
                msalService.logoutRedirect({ account });
            } else if (error instanceof BrowserAuthError && error.errorCode === 'monitor_window_timeout') {
                msalService.logoutRedirect({ account });
            }
            return throwError(() => error);
        })
    );
}
